<template>
	<v-app>
		<template v-if="$vuetify.breakpoint.xs">
			<v-main>
				<div
					class="d-flex justify-center align-center"
					style="height: 100vh"
				>
					Click Day Manager non attivo su smartphone
				</div>
			</v-main>
		</template>
		
		<template v-else>
			<v-overlay :value="isLoading">
				<v-progress-circular
					indeterminate
					size="64"
					color="primary"
				></v-progress-circular>
			</v-overlay>
			
			<v-app-bar
				v-if="$route.name != 'login'"
				app
				color="primary"
				dense
			>
				<v-toolbar-title>
					<slot>
						<!--<span class="mr-10" style="color: white">Click Day Manager</span>-->
						<div class="d-flex align-center">
							<router-link :to="{ name: 'home'}">
								<img
									src="https://s3.eu-central-1.amazonaws.com/manager.clickday.images/logo_negativo.png"
									alt="Click Day Manager"
									height="45"
									class="mr-10 tour-step-benvenuto"
									style="vertical-align: middle"
								>
							</router-link>
							<div
								style="color: white; font-size: 14px"
								class="mr-7 tour-step-utente-bando"
							>
								<div>
									<span class="font-weight-medium">Utente:</span> {{ user.email }}
								</div>
								<div>
									<span class="font-weight-medium">Bando attivo:</span> {{ bando?.nome }}
								</div>
							</div>
						</div>
					</slot>
				</v-toolbar-title>
				
				<v-spacer></v-spacer>
				
				<v-toolbar-items>
					<v-btn
						color="white"
						:to="tourIsRunning ? null : { name: 'impostazioni' }"
						text
						class="tour-step-impostazioni"
					>
						Impostazioni
					</v-btn>
					
					<v-btn
						v-if="isAccountManager"
						color="white"
						:to="{ name: 'clienti' }"
						text
					>
						Clienti
					</v-btn>
					
					<v-btn
						v-if="isAccountManager"
						color="white"
						:to="{ name: 'accordi' }"
						text
					>
						Accordi
					</v-btn>
					
					<v-btn
						v-if="isCliente && user.cliente?.tipologia != 'Azienda'"
						color="white"
						:to="tourIsRunning ? null : { name: 'materiale_informativo'} "
						text
						class="tour-step-4"
					>
						Materiale informativo
					</v-btn>
					
					<v-btn
						color="white"
						:to="tourIsRunning ? null : { name: 'pratiche'} "
						text
						class="tour-step-5"
					>
						Pratiche
					</v-btn>
					
					<v-btn
						v-if="!isCoordinatore"
						color="white"
						:to="tourIsRunning ? null : { name: 'contratti_di_servizio'} "
						text
						class="tour-step-menu-contratti-di-servizio"
					>
						Contratti di Servizio
					</v-btn>

					<v-btn
						v-if="isAccountManager"
						color="white"
						:to="tourIsRunning ? null : { name: 'conteggi'} "
						text
					>
						Conteggi
					</v-btn>
					
					<v-btn
						color="white"
						@click="tourIsRunning ? null : logout()"
						text
						class="tour-step-6"
					>
						Esci
					</v-btn>
				</v-toolbar-items>
				
				<v-btn
					v-if="user?.account_manager?.id === 4"
					icon
					@click="imperatoreGalatticoModeDialog = true"
				>
					<v-icon color="white" size="18">
						mdi-pill
					</v-icon>
				</v-btn>
				
				<!--&& bando?.id == 23-->
				<v-tooltip v-if="isCliente" bottom color="secondary">
					<template  v-slot:activator="{ on, attrs }">
						<v-btn
							icon
							@click="tourIsRunning ? null : manuallyStartTour()"
							class="tour-step-30"
							v-bind="attrs"
							v-on="on"
						>
							<v-icon color="white" size="19">mdi-help-circle-outline</v-icon>
						</v-btn>
					</template>
					<span>Mostra Guida</span>
				</v-tooltip>
				
				<v-btn
				  icon
					@click="tourIsRunning ? null : toggleTheme()"
				  class="tour-step-7"
				>
					<v-icon color="white" size="18">mdi-brightness-4</v-icon>
				</v-btn>
			</v-app-bar>
			
			<v-main>
				<v-container
					fluid
					:class="`${$route.name == 'login' ? 'background_login_image' : 'mt-3'}`"
				>
					<router-view></router-view>
				</v-container>
				
				<v-tour
					name="guida"
					:steps="bandoTourSteps"
					:options="tourOptions"
					:callbacks="tourCallbacks"
				>
					<template v-slot="tour">
						<transition name="fade">
							<v-step
								v-if="tour.steps[tour.currentStep] && showStep"
								:key="tour.currentStep"
								:step="tour.steps[tour.currentStep]"
								:previous-step="tour.previousStep"
								:next-step="tour.nextStep"
								:stop="tour.stop"
								:skip="tour.skip"
								:is-first="tour.isFirst"
								:is-last="tour.isLast"
								:labels="tour.labels"
								:highlight="tour.highlight"
							>
								<template v-if="hideNextButton(stepTargetName)">
									<div slot="actions">
										<button @click="tour.skip" class="v-step__button">{{ tourOptions.labels.buttonSkip }}</button>
										<button @click="tour.previousStep" class="v-step__button">{{ tourOptions.labels.buttonPrevious }}</button>
									</div>
								</template>
								
								<!--<template v-if="hidePreviousButton(stepTargetName)">-->
								<!--	<div slot="actions">-->
								<!--		<button @click="tour.skip" class="v-step__button">{{ tourOptions.labels.buttonSkip }}</button>-->
								<!--		<button @click="tour.nextStep" class="v-step__button">{{ tourOptions.labels.buttonNext }}</button>-->
								<!--	</div>-->
								<!--</template>-->
								
								<template v-if="stepTargetName == '.tour-step-30'">
									<div slot="actions">
										<button @click="tour.finish" class="v-step__button">{{ tourOptions.labels.buttonStop }}</button>
									</div>
								</template>
								
								<!--<template v-else>-->
								<!--	<div slot="actions">-->
								<!--		<v-btn-->
								<!--			small-->
								<!--			color="secondary"-->
								<!--			class="white&#45;&#45;text"-->
								<!--			@click="tour.nextStep"-->
								<!--		>-->
								<!--			SUCCESSIVO-->
								<!--		</v-btn>-->
								<!--	</div>-->
								<!--</template>-->
							</v-step>
						</transition>
					</template>
				</v-tour>
				
				<v-snackbar
					app
					:value="snackbarVisible"
					@input="setSnackbarVisible"
					:timeout="snackbarColor == 'error' ? 5000 : 3000"
					dense
					:color="snackbarColor"
					elevation="1"
				>
					<span class="font-weight-medium">{{ snackbarMessage }}</span>
				</v-snackbar>
				
			</v-main>
		</template>
		
		<v-dialog
			v-if="user?.account_manager?.id === 4"
			v-model="imperatoreGalatticoModeDialog"
			scrollable
			persistent
			width="unset"
		>
			<v-card>
				<v-card-title class="text-h5">
					Modalità Pollon
				</v-card-title>
				<v-card-text>
					<iframe
						width="560"
						height="315"
						src="https://www.youtube.com/embed/videoseries?si=EB82qIVgVJCycN0o&amp;list=PLqVP5_lrHw9Prm_L6Qvwh_S776bh2PgWM"
						title="YouTube video player"
						frameborder="0"
						allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
						referrerpolicy="strict-origin-when-cross-origin"
						allowfullscreen
					></iframe>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="tertiary"
						class="black--text"
						@click="imperatoreGalatticoModeDialog = false"
					>
						Chiudi
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-app>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { eventBus } from '@/event-bus.js';
export default {
	data() {
		return {
			isLoadingLogout: false,
			
			// tourSteps: [], // riempio in base al tipo di Cliente
			tourOptions: {
				useKeyboardNavigation: false,
				labels: {
					buttonSkip: 'SALTA GUIDA',
					buttonPrevious: 'PRECEDENTE',
					buttonNext: 'SUCCESSIVO',
					buttonStop: 'FINE'
				}
			},
			tourCallbacks: {
				onStart: this.onStartTour,
				onPreviousStep: this.onPreviousTourStep,
				onNextStep: this.onNextTourStep,
				onFinish: this.onFinishTour,
				onStop: this.onStopTour,
			},
			
			targetsNameHideNextButton: [
				'.tour-step-8',
				'.tour-step-17',
				'.tour-step-22',
				'.tour-step-23',
				'.tour-step-24',
				'.tour-step-25',
				'.tour-step-26',
				'.tour-step-27',
				'.tour-step-28',
				'.tour-step-29',
			],
			
			// targetsNameHidePreviousButton: [
			// 	'.tour-step-31',
			// ],
			
			imperatoreGalatticoModeDialog: false
		}
	},
	
	computed: {
		...mapGetters({
			bando: 'shared/bando',
			user: 'auth/user',
			isAccountManager: 'auth/isAccountManager',
			isCliente: 'auth/isCliente',
			isCoordinatore: 'auth/isCoordinatore',
			
			tourIsRunning: 'tour/isRunning',
			showStep: 'tour/showStep',
			bandoTourSteps: 'tour/bandoTourSteps', // temporaneo
			
			snackbarColor: 'systemSnackbar/color',
			snackbarMessage: 'systemSnackbar/message',
			snackbarVisible: 'systemSnackbar/visible'
		}),
		isLoading() {
			return this.isLoadingLogout;
		},
		stepTargetName() {
			if (this.tourIsRunning) return this.$tours['guida'].step.target;
			else return null
		},
	},

	created() {
		this.initTheme();
		
		eventBus.$on('start-tour', () => {
			this.startTour();
		});
	},

	methods: {
		...mapActions({
			logoutAction: 'auth/logout',
			composeBandoTourSteps: 'tour/composeBandoTourSteps'
		}),
		...mapMutations({
			setTourIsRunning: 'tour/SET_IS_RUNNING',
			setStartTourManually: 'tour/SET_START_MANUALLY',
			setShowStep: 'tour/SET_SHOW_STEP',
			setSnackbarVisible: 'systemSnackbar/SET_VISIBLE',
		}),
		async logout() {
			this.isLoadingLogout = true;
			await this.logoutAction();
			await this.$router.replace({ name: 'login' });
			this.isLoadingLogout = false;
		},
		toggleTheme() {
			this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
			localStorage.setItem('click_day_manager_dark_theme', this.$vuetify.theme.dark.toString());
		},
		initTheme() {
			const dark_theme = localStorage.getItem('click_day_manager_dark_theme');
			if(dark_theme) {
				this.$vuetify.theme.dark = dark_theme === 'true';
			}
		},
		manuallyStartTour() {
			if (this.$route.name != 'home') {
				this.setStartTourManually(true);
				this.$router.push({ name: 'home' }); // nella home viene avviato il tour in mounted()
			}
			else {
				this.startTour();
			}
		},
		startTour() {
			// const tipologiaCliente = this.user?.cliente.tipologia;
			
			this.composeBandoTourSteps();
			// this.composeTour();
			
			// TODO: adattare questo pezzo di codice
			// if (tipologiaCliente === 'Azienda') {
			// 	this.tourSteps = this.allTourSteps.filter(
			// 		step => step.target != '.tour-step-2'
			// 			&& step.target != '.tour-step-4'
			// 	);
			// }
			// else this.tourSteps = this.allTourSteps;
			
			setTimeout(() => {
				this.$tours['guida'].start();
			}, 100)
		},
		onStartTour() {
			this.setTourIsRunning(true);
		},
		onPreviousTourStep() {
			if (this.stepTargetName == '.tour-step-9') {
				this.$router.push({ name: 'home' });
			}
			else if (this.stepTargetName == '.tour-step-18') {
				eventBus.$emit('close-pratica-dialog');
			}
			else if (this.stepTargetName == '.tour-step-22') {
				this.setShowStep(false);
				setTimeout(() => {
					this.setShowStep(true);
				}, 300)
				eventBus.$emit('set-active-tab', 0);
			}
			else if (this.stepTargetName == '.tour-step-23') {
				eventBus.$emit('set-active-tab', 1);
			}
			else if (this.stepTargetName == '.tour-step-24') {
				eventBus.$emit('set-active-tab', 2);
			}
			else if (this.stepTargetName == '.tour-step-25') {
				eventBus.$emit('set-active-tab', 3);
			}
			else if (this.stepTargetName == '.tour-step-26') {
				eventBus.$emit('set-active-tab', 4);
			}
			else if (this.stepTargetName == '.tour-step-27') {
				eventBus.$emit('set-active-tab', 5);
			}
			else if (this.stepTargetName == '.tour-step-28') {
				eventBus.$emit('set-active-tab', 6);
			}
			else if (this.stepTargetName == '.tour-step-29') {
				eventBus.$emit('set-active-tab', 7);
			}
		},
		onNextTourStep() {
			if (this.stepTargetName == '.tour-step-21') {
				eventBus.$emit('set-active-tab', 1)
			}
		},
		onFinishTour() {
			this.setTourIsRunning(false);
			this.updateGuidaConclusa();
		},
		onStopTour() {
			this.setTourIsRunning(false);
			this.updateGuidaConclusa();
		},
		hideNextButton(stepTargetName) {
			return this.targetsNameHideNextButton.includes(stepTargetName);
		},
		// hidePreviousButton(stepTargetName) {
		// 	return this.targetsNameHidePreviousButton.includes(stepTargetName);
		// },
		updateGuidaConclusa() {
			if (this.user.cliente.guida_conclusa) return
			let formData = new FormData();
			formData.append('cliente', JSON.stringify({
				guida_conclusa: true
			}));
			axios.patch(`/api/clienti/${this.user.cliente.id}`, formData, {
				headers: { 'Content-Type': 'multipart/form-data' }
			})
		},
		// composeTour() {
			// for (const key in this.allTourSteps) {
			// 	if (this.allTourSteps[key].hasOwnProperty('nascondiInQuestiBandi')) {
			// 		if (!this.allTourSteps[key].hideInTheseBandi.includes(this.bando.id)) {
			// 			this.tourSteps.push(this.allTourSteps[key]);
			// 		}
			// 	}
			// 	else this.tourSteps.push(this.allTourSteps[key]);
			// }
		// }
	}
}
</script>

<style>
.v-step {
	max-width: 400px !important;
	background-color: #f1861b !important;
}
.v-step__button-next {
	background-color: #2196f3 !important;
	border-color: #2196f3 !important;
}
.v-step__button-next:hover {
	color: white !important;
	background-color: #2196f3 !important;
}
.v-step__arrow {
    /*border: 2px solid #f1861b;*/
}
.v-tour__target--highlighted {
    box-shadow: 0 0 0 4px rgb(33, 150, 243);
}
.v-tour__target--highlighted--inset {
    box-shadow: inset 0 0 0 4px rgb(33, 150, 243);
}

.background_login_image {
	background: url('https://s3.eu-central-1.amazonaws.com/manager.clickday.images/sfondo_login.png');
	background-size: cover;
	height: 100vh;
}

</style>

